import URL from 'utils/URL';

export const urlQuery = URL.current().query;

/* --------------- 环境判断的相关常量 --------------- */
export const IS_DEV = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';
export const IS_STAGING = window.location.host.includes('-staging');

const userAgent = navigator.userAgent;

// 是否是TUSDK，目前支持 EWB
export const IS_TUPSDK = /tupsdk/i.test(userAgent);

// 是否是老虎自营，嵌入到其他三方时，这里为false，部分业务会做一些调整。
export const IS_TIGER_SELF = !IS_TUPSDK;

export const SDK_CLIENT = IS_TUPSDK ? userAgent.match(/TUPSDK_([A-Z]+)/)?.[1] : null;

// 支持的theme
export const SUPPORT_THEME_MAP = {
    EWB: 'ewb-theme'
};

/* --------------- 存放全局使用的变量 --------------- */
// 鉴于ira验收周期过长, 所以临时隐藏ira, 方便后续代码开发合并, 验收完毕打开的时候需要重新回测
// 部分业务, 比如加盟等, 仍然需要限制是否显示ira, 所以这里需要保留此开关
export const HIDE_IRA = IS_TUPSDK; // 是否隐藏IRA

/** 地址和邮编不匹配提示文案 */
export const ZIP_CODE_NOT_MATCH_ADDRESS_TEXT = __(
    'Please check and make sure the combination of the state and zip code you provided is correct.'
);

export const ESOP_OPEN_ACCOUNT_REDIRECT = 'ESOP_OPEN_REDIRECT';
